export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./popover.vue?vue&type=template&id=109552e0&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/pages/events/components/popover/popover.vue?vue&type=template&id=109552e0&
// module id = 959
// module chunks = 0